import { Alert, Box, Button, Typography } from '@mui/material';
import type { CommunicationStepKey, ValidationIssue } from '../../../../../utils/checkOperationErrors';

interface ValidationIssuesAlertProps {
  issues: ValidationIssue[];
  canFix: (step: CommunicationStepKey) => boolean;
  onFix: (step: CommunicationStepKey) => void;
  onClose: () => void;
}

function ValidationIssuesAlert({ issues, canFix, onFix, onClose }: ValidationIssuesAlertProps) {
  return (
    <Alert severity="error" onClose={onClose} sx={{ mb: 1, py: 0.25 }}>
      <Typography variant="body2" fontWeight={700} sx={{ mb: 0.5 }}>
        La campagne ne peut pas être validée, merci de corriger :
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
        {issues.map(({ message, step }, index) => (
          <li key={index}>
            <Typography variant="body2" component="span">{message}</Typography>
            {step && canFix(step) && (
              <Button
                size="small"
                color="inherit"
                onClick={() => onFix(step)}
                sx={{ ml: 1, textTransform: 'none', textDecoration: 'underline', minWidth: 0, py: 0 }}
              >
                Corriger
              </Button>
            )}
          </li>
        ))}
      </Box>
    </Alert>
  );
}

export default ValidationIssuesAlert;
